import { MatTableDataSource } from '@angular/material/table/typings/table-data-source';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { Component, OnInit } from '@angular/core';
import { WizardStep } from 'src/app/wizard/wizard.component';
import { MedicalServiceWizardService } from 'src/app/services/wizard/medical-service/medical-service-wizard';
import { StudyReportWizardService } from 'src/app/services/wizard/study-report/study-report.wizard.service';

@Component({
  selector: 'app-study-report-consultation-history-component',
  templateUrl: './study-report-consultation-history.component.html'
})
export class StudyReportConsultationHistoryComponent implements OnInit, WizardStep {

  completed: boolean;
  isInit: boolean;
  medicalAppointmentId: number;
  patientId: number;

  constructor(private studyReportWizardService: StudyReportWizardService) {
     this.medicalAppointmentId = this.studyReportWizardService.medicalAppointmentId;
     this.patientId = this.studyReportWizardService.patientId;
  }

  ngOnInit(): void {
  }

  get valid(): boolean {
    return this.completed;
  }


  loaded() {
    this.completed = true;
  }

  activate(): void {
  }

  save(): void {

  }
}
